import React from "react";
import {FaCopy} from "react-icons/fa";
import {Card} from "../../../../../components/card/card.jsx";
import Button from "../../../../../components/button/button.jsx";

const ScheduleAttendanceActionsCard = ({
    id,
    isSaving,
    onDelete,
    onSaveAndCopy,
    onSaveAndAdd,
    onSave,
}) => (
    <Card>
        <Card.Body className="flex gap-2 justify-end">
            {id && <Button target="danger" onClick={onDelete} actionFeedbackType='delete'>Excluir</Button>}
            {id && <Button target="primary-outline" onClick={onSaveAndCopy} actionFeedbackType="save"><FaCopy/>Salvar e copiar</Button>}
            <Button target="primary-outline" onClick={onSaveAndAdd} actionFeedbackType='save'>Salvar e adicionar novo</Button>
            <Button onClick={onSave} actionFeedbackType='save'>Salvar</Button>
        </Card.Body>
    </Card>
);

export default ScheduleAttendanceActionsCard;